import { render } from "./index.vue?vue&type=template&id=c338e0b0&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.less?vue&type=style&index=0&id=c338e0b0&lang=less&scoped=true"
import "./index.vue?vue&type=style&index=1&id=c338e0b0&lang=css"

import exportComponent from "/Users/jinzhouhang/work/zhanhai/beautifuldai-h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c338e0b0"]])

export default __exports__